module.exports = __webpack_public_path__ + "img/computer-age-2.c2f6771a.png";